import type { CatalogItem, CatalogItemTranslation } from "@albertine/types/openapi/lmt";
import { Lib } from "albertine-shared-web";
import {
    showEventDates,
    showTravelItineraryNotes,
} from "../../../common/utils/catalog.util";
import Label from "../../Common/Label";
import Paragraph from "../../Common/Paragraph";

type LanguageTabProps = {
    item: CatalogItem;
    translation: CatalogItemTranslation;
};

export function LanguageTab(props: LanguageTabProps) {
    const { item, translation } = props;

    const {
        description,
        headline,
        eventDates,
        travelItineraryNotes,
        localInsights,
        benefits,
        bookingPolicy,
        name,
    } = translation;

    return (
        <Lib.Flex.Column gap="value24">
            {name ? <h2>{name}</h2> : <h2>{item.name}</h2>}
            {headline ? <h3>{headline}</h3> : <h3>Description</h3>}
            <Paragraph.Medium>
                {description || (
                    <Label.Medium.Light.N60>
                        What is this place like? Who is it for?
                    </Label.Medium.Light.N60>
                )}
            </Paragraph.Medium>
            {showEventDates(item.offeringCategories) && (
                <Lib.Flex.Column gap="value16">
                    <h4>Event dates</h4>
                    <Paragraph.Medium>
                        {eventDates || (
                            <Label.Medium.Light.N60>
                                Use the international date format 2 May 2023
                            </Label.Medium.Light.N60>
                        )}
                    </Paragraph.Medium>
                </Lib.Flex.Column>
            )}
            {showTravelItineraryNotes(item.offeringCategories) && (
                <Lib.Flex.Column gap="value16">
                    <h4>Ideal trip time and duration</h4>
                    <Paragraph.Medium>
                        {travelItineraryNotes || (
                            <Label.Medium.Light.N60>
                                E.g. 1–2 weeks, best between Jun-Sep
                            </Label.Medium.Light.N60>
                        )}
                    </Paragraph.Medium>
                </Lib.Flex.Column>
            )}
            <Lib.Flex.Column gap="value16">
                <h4>Albertine insight</h4>
                <Paragraph.Medium>
                    {localInsights || (
                        <Label.Medium.Light.N60>
                            What&apos;s special about this place?
                        </Label.Medium.Light.N60>
                    )}
                </Paragraph.Medium>
            </Lib.Flex.Column>
            <Lib.Flex.Column gap="value16">
                <h4>Albertine benefit</h4>
                <Paragraph.Medium>
                    {benefits || (
                        <Label.Medium.Light.N60>
                            Why book through Albertine?
                        </Label.Medium.Light.N60>
                    )}
                </Paragraph.Medium>
            </Lib.Flex.Column>
            <Lib.Flex.Column gap="value16">
                <h4>Booking policy</h4>
                <Paragraph.Medium>
                    {bookingPolicy || (
                        <Label.Medium.Light.N60>
                            Is there a deposit? Can I cancel? Any other T&C&apos;s the
                            customer should know?
                        </Label.Medium.Light.N60>
                    )}
                </Paragraph.Medium>
            </Lib.Flex.Column>
        </Lib.Flex.Column>
    );
}
